export function buildExploreHref(restaurantSlug: string, currentSearch: string): string {
	const cleaned = currentSearch.startsWith('?') ? currentSearch.slice(1) : currentSearch;
	const suffix = cleaned.length > 0 ? `?${cleaned}` : '';
	return `/${restaurantSlug}/explore${suffix}`;
}
